var fn = function( obj ){
var __t,__p='';
__p+='#version 300 es\n\nprecision highp float;\n\nin vec2 vTexCoord0;\n\nuniform sampler2D tTex;\nuniform vec2 uDirection;\n\nout vec4 FragColor;\n\n// https://lisyarus.github.io/blog/posts/blur-coefficients-generator.html\nconst int SAMPLE_COUNT = 16;\n\nconst float OFFSETS[16] = float[16](\n    -14.483900402871722,\n    -12.486119702716191,\n    -10.488339607496174,\n    -8.490560081923437,\n    -6.492781048464156,\n    -4.495002299751391,\n    -2.497223324761885,\n    -0.499443592819785,\n    1.4983334334796028,\n    3.4961128918527606,\n    5.493891660460469,\n    7.491670512109869,\n    9.489449776634325,\n    11.48722958134352,\n    13.485009975300198,\n    15.0\n);\n\nconst float WEIGHTS[16] = float[16](\n    0.047721724474168795,\n    0.05379656812404862,\n    0.05957772334915251,\n    0.06481922486900471,\n    0.06928096834572818,\n    0.07274681857426482,\n    0.07504204260415345,\n    0.07604811535758985,\n    0.0757111326449614,\n    0.07404963000096675,\n    0.0711504626195665,\n    0.06716184882707205,\n    0.06228128557526437,\n    0.05673915845627556,\n    0.050780734478999,\n    0.02309256169878361\n);\n\n\n\nvec4 blur(in sampler2D sourceTexture, vec2 blurDirection, vec2 pixelCoord)\n{\n    vec4 result = vec4(0.0);\n    vec2 size = vec2(textureSize(sourceTexture, 0));\n    for (int i = 0; i < SAMPLE_COUNT; ++i)\n    {\n        vec2 offset = blurDirection * OFFSETS[i] / size;\n        float weight = WEIGHTS[i];\n        result += texture(sourceTexture, pixelCoord + offset) * weight;\n    }\n    return result;\n}\n\n\n\nvoid main(void){\n  vec4 color = blur(tTex, uDirection, vTexCoord0);\n\n  FragColor = color;\n}';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
